import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import MoveModal from '../components/MoveModal';
import Loader from '../components/Loader';
import { useAuth } from '../contexts/AuthContext';
import fetchJson from '../hooks/fetchJson';
import Pagination from '../components/Pagination';

const MoveStore = () => {
  const [showModal, setShowModal] = useState(false);
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const { user, token } = useAuth();
  const headers = useMemo(() => {
    const h = { 'Content-Type': 'application/json' };
    if (token) h['Authorization'] = `Bearer ${token}`;
    if (user?.ownerId) h['x-owner-id'] = String(user.ownerId);
    if (user?.staffId) h['x-staff-id'] = String(user.staffId);
    return h;
  }, [user, token]);

  const loadTransfers = async () => {
    setLoading(true);
    try {
      const { data, error } = await fetchJson('/api/move-store/transfers', { headers });
      if (error) throw new Error(error);
      setTransfers(data?.items || []);
      setCurrentPage(1);
    } catch (e) {
      setTransfers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTransfers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmitted = () => {
    setShowModal(false);
    loadTransfers();
  };

  const pagedTransfers = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return transfers.slice(start, start + itemsPerPage);
  }, [transfers, currentPage, itemsPerPage]);

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Ko'chirish</h2>
        <Button variant="success" onClick={() => setShowModal(true)}>
          <FaPlus className="me-2" /> Ko'chirish
        </Button>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">Ko'chirishlar</h5>
            <Button variant="outline-secondary" size="sm" onClick={loadTransfers} disabled={loading}>
              Yangilash
            </Button>
          </div>
          {loading ? (
            <div className="py-3"><Loader /></div>
          ) : transfers.length === 0 ? (
            <div className="alert alert-info mb-0">Hozircha ko'chirishlar yo'q.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Sana</th>
                    <th>Qayerdan</th>
                    <th>Qayerga</th>
                    <th>Mahsulot</th>
                    <th>Miqdor</th>
                    <th>Shtrixkod</th>
                    <th>Mas'ul</th>
                  </tr>
                </thead>
                <tbody>
                  {pagedTransfers.map(t => (
                    <tr key={t.id}>
                      <td>{t.created_at ? new Date(t.created_at).toLocaleString() : '-'}</td>
                      <td>{t.from_store || '-'}</td>
                      <td>{t.to_store || '-'}</td>
                      <td>{t.product_name || '-'}</td>
                      <td>{Number(t.quantity_transfered || 0)}</td>
                      <td>{t.barcode || '-'}</td>
                      <td>{t.doer || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalItems={transfers.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
                onItemsPerPageChange={(n) => { setItemsPerPage(n); setCurrentPage(1); }}
              />
            </div>
          )}
        </div>
      </div>

      <MoveModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmitted={handleSubmitted}
      />
    </div>
  );
};

export default MoveStore;